//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import Validator from '../../../services/Validator/Validator';
import {
    API_CREATE_ARTICLE,
    API_DELETE_ARTICLE,
    API_GET_ALL_ARTICLES,
    API_UPDATE_ARTICLE,
} from './ArticleConstants';
import ArticleResultsPojo from './ArticleResultPojo';

export class ArticleService {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async getAll(): Promise<ArticleResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_ARTICLES,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                articles: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async delete(articleId: number, status: number): Promise<Boolean> {
        try {
            this.validator.validatePositiveInteger(articleId);
            this.validator.validateIntegerIncludingZero(status);

            const httpResult = await this.httpService.delete(
                API_DELETE_ARTICLE,
                { articleId, status },
            );
            return httpResult.data.isSuccess;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async create(
        name: string,
        isFooterLink: number,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.isValidString('Name', name);
            this.validator.validateIntegerIncludingZero(isFooterLink);

            const payload = {
                name,
                isFooterLink,
            };

            const httpResult = await this.httpService.post(
                API_CREATE_ARTICLE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async update(
        articleId: number,
        name: string,
        isFooterLink: number,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.validatePositiveInteger(articleId);
            this.validator.isValidString('Name', name);
            this.validator.validateIntegerIncludingZero(isFooterLink);

            const payload = {
                articleId,
                name,
                isFooterLink,
            };
            const httpResult = await this.httpService.put(
                API_UPDATE_ARTICLE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
